<template>
  <div class="wrapper-content w-100">
    <h1>{{title}}</h1>
    <div>
      <LmBreadcrumb v-if="showBreadcrumb" />
      <h5>Expediente: {{itemDetail.expediente}}</h5>
      <h5>Oficina: {{itemDetail.nombre_oficina}}</h5>
      <div>
        <div class="row">
          <div class="col-12 col-lg-8">
            <LmSuperPowerSelect
              :data="accionSelectOptions"
              :tbColumns="lmsuperpowerselectTbColumnsAcciones"
              label="Accion Realizada"
              title="Accion Realizada"
              placeholder="Accion Realizada"
              @values="updateAccionRealizada"
              :v="$v.form.accionRealizada"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-lg-8">
            <LmTextInput
              v-model="form.numero"
              :v="$v.form.numero"
              label="Numero"
              placeholder="Numero"
              />
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-lg-8">
            <LmTextArea
              v-model="form.mensaje"
              :v="$v.form.mensaje"
              label="Mensaje"
              placeholder="Mensaje de respuesta"
              />
          </div>
        </div>
        <!-- <div class="row">
          <div class="col-12 col-lg-8 mb-3">
            <LmUploadFiles
              :dropzoneOptions="dropzoneOptions"
            />
          </div>
        </div> -->
      </div>
      <form
        @submit.prevent="submit"
        novalidate
        class="position-relative">
        <LmButton
          v-if="enableGoBackButton"
          type="button"
          buttonClass="btn-secondary"
          :value="$t('go_back')"
          @click.native="goBackBtn"
          lmButtonRootWrapperClass="d-inline-block"
          lmButtonWrapperClass="col"
          />
        <LmButton
          v-if="!enableGoBackButton"
          type="submit"
          buttonClass="btn-primary"
          :isProcessing="formIsProcessing"
          :value="$t('Save')"
          lmButtonRootWrapperClass="d-inline-block mr-1"
          lmButtonWrapperClass="col"
          />
        <LmButton
          v-if="!enableGoBackButton"
          type="button"
          buttonClass="btn-secondary"
          :value="$t('Cancel')"
          @click.native="cancelBtn"
          lmButtonRootWrapperClass="d-inline-block"
          lmButtonWrapperClass="col"
          />
      </form>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import LmEmailInput from '@/components/form/elements/LmEmailInput'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmNumberInput from '@/components/form/elements/LmNumberInput'
import LmTextArea from '@/components/form/elements/LmTextArea'
import LmSelect from '@/components/form/elements/LmSelect'
import LmDateTime from '@/components/form/elements/LmDateTime'
import LmDate from '@/components/form/elements/LmDate'
import LmButton from '@/components/form/elements/LmButton'
import LmComponentLoading from '@/components/LmComponentLoading'
import LmSuperPowerSelect from '@/components/form/elements/LmSuperPowerSelect.vue'
import LmUploadFiles from '@/components/LmUploadFiles'

export default {
  components: {
    LmTextInput,
    LmNumberInput,
    LmEmailInput,
    LmButton,
    LmTextArea,
    LmSelect,
    LmDateTime,
    LmDate,
    LmComponentLoading,
    LmSuperPowerSelect,
    LmUploadFiles
  },
  data () {
    return {
      showBreadcrumb: process.env.VUE_APP_SHOWBREADCRUMB === 'yes',
      lmsuperpowerselectTbColumnsAcciones: [
        { title: 'id', data: 'id' },
        { title: 'Oficina', data: 'name' }
      ],
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_URL}documentos/nuevo/?id=${this.$route.params.id}`,
        headers: {
          'Cache-Control': null,
          'X-Requested-With': null
        },
        withCredentials: true,
        thumbnailWidth: 150,
        maxFilesize: 1.5,
        addRemoveLinks: true
      },
      form: {
        accionRealizada: null,
        idAccionRealizada: null,
        numero: '',
        mensaje: ''
      },
      accionSelectOptions: [
        {
          id: 1,
          name: 'Dictamen'
        },
        {
          id: 2,
          name: 'Previo'
        },
        {
          id: 3,
          name: 'Tomado conocimiento'
        },
        {
          id: 4,
          name: 'Sugiriendo archivo'
        },
        {
          id: 5,
          name: 'Carpeta de juicio'
        },
        {
          id: 6,
          name: 'A pedido'
        },
        {
          id: 7,
          name: 'Otros'
        }
      ],
      formIsProcessing: false
    }
  },
  computed: {
    ...mapState('commons', ['itemDetail'])
  },
  props: {
    id: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    // La uri tanto para obtener la configuracion desde settings como
    // para interactuar con el endpoint que obtiene y persiste los datos
    // para la edicion
    newOrEditEndpointUri: {
      type: String,
      required: true
    },
    isOnEditMode: {
      type: Boolean,
      required: true,
      default: false
    },
    enableGoBackButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  validations: {
    form: {
      accionRealizada: {
        required
      },
      mensaje: {
        required
      }
    }
  },
  methods: {
    ...mapActions('commons', ['updateItemDetail', 'getItemDetail']),
    ...mapActions('settings', ['geAddOrEditSettings']),
    ...mapActions('session', ['getUserInfo']),
    goBackBtn () {
      this.$router.push(this.onSuccessDestinationRoute)
    },
    cancelBtn () {
      this.$router.push(`/pasesinternos/delexpediente/${this.$route.params.parentid}`)
    },
    submit () {
      this.$v.form.$touch()
      if (!this.$v.form.$pending && !this.$v.form.$error) {
        this.formIsProcessing = true
        let insertAttributes = {
          id: this.$route.params.parentid,
          legajo: this.form.legajo,
          mensaje: this.form.mensaje,
          oficina: this.itemDetail.oficina
        }
        this.updateItemDetail({
          path: 'pasesinternos/cerrar/',
          data: insertAttributes
        })
          .then(() => {
            this.formIsProcessing = false
            this.$router.push(`/pasesinternos/delexpediente/${this.$route.params.parentid}`)
          })
          .catch(e => {
            this.formIsProcessing = false
            console.log(e)
            alert(this.$t('try_again_later'))
          })
      }
    },
    updateAccionRealizada (value) {
      if (value.length) {
        this.form.idAccionRealizada = value[0].id
        this.form.accionRealizada = value[0].name
      } else {
        this.form.idAccionRealizada = ''
        this.form.accionRealizada = ''
      }
    },
    sanitizeModel (model) {
      return model ? model.toString() : ''
    }
  },
  created () {
    (async () => {
      // Se obtiene el ID de oficina del usuario logeado
      this.paseDetail = await this.getItemDetail({
        path: 'pases/edit/',
        id: this.$route.params.parentid
      })
    })()

    // commonsApi.getSelectOptions({
    //   path: 'oficinas/predictivo/',
    //   total: 1000
    // })
    //   .then(response => {
    //     this.accionSelectOptions = response
    //   })
    //   .catch(error => {
    //     console.log('error: ', error)
    //   })
  }
}
</script>

<style lang="sass" scoped>
  hr
    border-top: 2px solid !important
    margin-top: 50px !important
    margin-bottom: 20px !important
  h4, h5
    margin-bottom: 30px !important
</style>
